// extracted by mini-css-extract-plugin
module.exports = {"ctn":"Dashboard_ctn__w4SJR","title":"Dashboard_title__2Yaqv","description":"Dashboard_description__3aUXI"};